import { Input } from "./ui/input";
import { Label } from "./ui/label";

export type DateRange = { from: string; to: string };
export type Granularity = "day" | "hour";

type Props = {
  value: DateRange;
  onChange: (next: DateRange) => void;
  granularity: Granularity;
  onGranularityChange: (g: Granularity) => void;
};

export function DateRangePicker({
  value,
  onChange,
  granularity,
  onGranularityChange,
}: Props) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="space-y-1">
        <Label htmlFor="from">Von</Label>
        <Input
          id="from"
          type="date"
          value={value.from}
          onChange={(e) => onChange({ ...value, from: e.target.value })}
          className="w-40"
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor="to">Bis</Label>
        <Input
          id="to"
          type="date"
          value={value.to}
          onChange={(e) => onChange({ ...value, to: e.target.value })}
          className="w-40"
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor="granularity">Granularität</Label>
        <select
          id="granularity"
          value={granularity}
          onChange={(e) =>
            onGranularityChange(e.target.value as Granularity)
          }
          className="h-9 rounded-md border border-input bg-background px-2 text-sm"
        >
          <option value="day">Tag</option>
          <option value="hour">Stunde</option>
        </select>
      </div>
    </div>
  );
}

export function defaultRange(days = 30): DateRange {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - days);
  const fmt = (d: Date) => d.toISOString().slice(0, 10);
  return { from: fmt(from), to: fmt(to) };
}

export function rangeToParams(
  r: DateRange,
): { from: string; to: string } {
  // Backend binds `?from=` / `?to=` via Query(alias=...). Match the URL
  // params verbatim — axios serialises the object key as the param name.
  return {
    from: `${r.from}T00:00:00Z`,
    to: `${r.to}T23:59:59Z`,
  };
}
